import { driverVehicleLinkSchema } from './driver-vehicle-link.schema';
import { z } from 'zod/v4';

export const vehicleDriverLinkSchema = z.object({
  vehicleId: z.string(),
  vehicleDriverLinks: z.array(driverVehicleLinkSchema),
});

export type VehicleDriverLink = z.infer<typeof vehicleDriverLinkSchema>;
